module.exports = __webpack_public_path__ + "img/mute.ea188ed9.png";